import { render, staticRenderFns } from "./veJkyReportAdmin.vue?vue&type=template&id=04c43b94&scoped=true"
import script from "./veJkyReportAdmin.vue?vue&type=script&lang=js"
export * from "./veJkyReportAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c43b94",
  null
  
)

export default component.exports